import React from "react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Trans} from "@lingui/macro";
import {MapAssetResult} from "../asset-map/asset-map";
import {AssetWithImage} from "../../../../models";

interface MapModalProps {
    closeMapModal: () => void
    asset: AssetWithImage
}

interface MapModalState {

}

export class MapModal extends React.Component<MapModalProps, MapModalState>
{
    render(){
        return (
            <Dialog open={true} onClose={this.props.closeMapModal} fullWidth maxWidth={"lg"}>
                <DialogTitle>
                    <Trans id={"af-map"}>
                        Visualizzazione immobile nella mappa
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    {
                        this.props.asset &&
                        <MapAssetResult assetData={this.props.asset} location={{
                            longitude: this.props.asset.asset.location.coordinates[0],
                            latitude: this.props.asset.asset.location.coordinates[1]
                        }} />
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeMapModal}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"asset-details.asset-form.close-map"}>
                            Chiudi
                        </Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
